(function (Drupal, once) {
  Drupal.behaviors.newsResults = {
    attach: function attach(context) {
      function focusResultCount() {
        const results = document.querySelectorAll('.c-news-updates__results');
        // Get the search results, focus and set tabindex.
        results.forEach((result) => {
          console.log(`result: ${result}`);
          result.setAttribute('tabindex', '-1');
          result.focus();
        });
      }
      function catchAjax(list, observer) {
        list.getEntries().forEach((entry) => {
          // If this is a Drupal Views Ajax call, focus the results count.
          if (entry.name.includes('/views/ajax?')) {
            setTimeout(focusResultCount, 500);
          }
        });
      }
      once('newsResults', 'html', context).forEach(function () {
        // Run a PerformanceObserver to watch for requests.
        const observer2 = new PerformanceObserver(catchAjax);
        observer2.observe({ entryTypes: ['resource'] });
      });
    },
  };
})(Drupal, once);
